import React, { Component } from "react";
import Index1 from "../MainContent/index1";
import Index2 from "../MainContent/index2";
import Index3 from "../MainContent/index3";
import Index4 from "../MainContent/index4";
import Index5 from "../MainContent/index5";
import Index6 from "../MainContent/index6";
import Index7 from "../MainContent/index7";
import Index8 from "../MainContent/index8";

import { Routes, Route } from "react-router-dom";

class MainBuilder extends Component {
  render() {
    return (
      <Routes>
        <Route path="/index-1" element={<Index1 />} />
        <Route path="/index-2" element={<Index2 />} />
        <Route path="/index-3" element={<Index3 />} />
        <Route path="/index-4" element={<Index4 />} />
        <Route path="/index-5" element={<Index5 />} />
        <Route path="/index-6" element={<Index6 />} />
        <Route path="/index-7" element={<Index7 />} />
        <Route path="/index-8" element={<Index8 />} />
        <Route path="/" element={<Index1 />} />
      </Routes>
    );
  }
}

export default MainBuilder;
